import React, { useState } from 'react';
import { Box, IconButton, Menu, MenuItem, Typography } from '@mui/material';
import { AccountCircle as AccountCircleIcon } from '@mui/icons-material';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from 'src/contexts/AuthContext';
import { useContext } from 'react';
import { getCurrentCompanyId } from 'src/modules/companies/slices';
import { selectProfile } from 'src/modules/profile/slices';
import { useHandleSelectedCompany } from 'src/hooks/useHandleSelectedCompany';
import { handleLogout } from 'src/helpers/helpers';
import { isBhiAdmin } from 'src/helpers/permissions';
import { CompanySwitcher } from 'src/components/CompanySwitcher';

export const MobileHeader: React.FC = () => {
  const [anchorElUser, setAnchorElUser] = useState<null | HTMLElement>(null);
  const authContext = useContext(AuthContext);
  const companyId = useSelector(getCurrentCompanyId);
  const selectedCompanyId = localStorage.getItem('bhiCurrentCompany') ?? companyId;
  const { profile } = useSelector(selectProfile);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { switchCompany } = useHandleSelectedCompany();

  const handleOpenUserMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorElUser(event.currentTarget);
  };

  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };

  return (
    <Box sx={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'end',
      width: '100%',
      gap: 0.5,
      padding: '0 4px',
    }}>
      <Box sx={{ width: 40 }} />

      {selectedCompanyId && (
        <CompanySwitcher
          selectedCompanyId={selectedCompanyId}
          onSwitch={switchCompany}
          variant="mobile"
        />
      )}

      <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
        <AccountCircleIcon sx={{ fontSize: 40 }} />
      </IconButton>

      <Menu
        sx={{ mt: '45px' }}
        id="menu-appbar"
        anchorEl={anchorElUser}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        keepMounted
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        open={Boolean(anchorElUser)}
        onClose={handleCloseUserMenu}
      >
        <MenuItem key={'profile'} onClick={() => navigate('/profile')}>
          <Typography textAlign="center">{'My Profile'}</Typography>
        </MenuItem>
        {isBhiAdmin(profile) && (
          <MenuItem key={'companies'} onClick={() => navigate('/admin/companies')}>
            <Typography textAlign="center">{'Admin'}</Typography>
          </MenuItem>
        )}
        <MenuItem key={'logout'} onClick={() => handleLogout(authContext, dispatch)}>
          <Typography textAlign="center">{'Log out'}</Typography>
        </MenuItem>
      </Menu>
    </Box>
  );
};
